import type { ReactNode } from 'react';

export const symbol_japanese_flag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M739-307v-361q-75 5-146.5-11.5T463-731q-41-25-84.45-37T290-780q-17 0-34.5 2t-36.5 6v359q17-2 35.5-3.5T294-418q59 0 118 16t110 46q51 30 105.2 42 54.21 12 111.8 7ZM561.5-460.29q33.5-33.29 33.5-81.5t-33.29-81.71q-33.29-33.5-81.5-33.5t-81.71 33.29q-33.5 33.29-33.5 81.5t33.29 81.71q33.29 33.5 81.5 33.5t81.71-33.29ZM498-300q-48-29-100.14-43.5T292-358q-17 0-34 1.5t-38 5.5v201q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-644q0-11.43 6.99-20.57 6.98-9.14 18.01-11.43 35-8 59-11t47-3q52 0 102.5 14.5T489-784q47 28 100 42.5T696-727q19.48 0 37.24-1t34.76-3q12.65-2 22.33 7.18Q800-714.64 800-702v422q0 12.1-7.95 20.79-7.94 8.7-20.05 10.21-19 2-37.5 3.5T697-244q-52 0-102.5-14T498-300Zm-19-240Z"
		/>
	</svg>
);
